export default {"src":"/_next/static/media/logo.2bc9cebc.svg","height":2635,"width":3780};